import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import TextEditor from '../../components/TextEditor/TextEditor';
import CustomDropdown from '../../components/Inputs/CustomDropdown';
import { GetCategoriesList, CreateTopic } from '../../utils/api/services/forum.js';
import paths from '../../paths';
import GlobalPreloader from '../../components/Preloader/GlobalPreloader';
import { getCleanText } from '../../utils/helpers';
import MessageModal from '../../components/Modals/MessageModal';

export default class ForumTopicCreate extends Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);

    this.titleMinLength = 5;
    this.titleMaxLength = 100;
    this.messageMinLength = 10;
    this.messageMaxLength = 1000;

    this.state = {
      editorHtml: '',
      title: '',
      selectedCategory: {},
      categories: [],
      isLoading: false,
      attachments: [],
      showModalMessage: false,
      modalMessage: '',
      modalTitle: '',
    };
  }

  componentWillMount = () => {
    this.getCategories();
  };

  getCategories = () => {
    GetCategoriesList()
      .then((result) => {
        this.setState(
          {
            categories: result,
          },
          this.setDefaultCategory,
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };

  setDefaultCategory = () => {
    const categoryFromUrl = this.state.categories.find(
      item => item.alias === this.props.match.params.alias,
    );
    if (categoryFromUrl) {
      this.setState(
        {
          selectedCategory: categoryFromUrl,
        },
      );
    }
  };

  handleSelectedCategoryChange = (selectedCategory) => {
    this.setState({ selectedCategory });
  };

  handleTitleChange = (e) => {
    this.setState({
      title: e.currentTarget.value,
    });
  };

  handleTextChange = (editorHtml) => {
    this.setState({
      editorHtml,
    });
  };

  createTopic = (formData) => {
    CreateTopic(formData)
      .then((topic) => {
        this.setState(
          {
            topic,
            isLoading: true,
          },
          () => this.props.history.push(`${paths.advocates.forumTopic}/${topic.alias}`),
        );
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  setAttachments = (attachments) => {
    this.setState({
      attachments,
    });
  };

  handlePostAction = (e) => {
    const {
      selectedCategory, title, editorHtml, attachments,
    } = this.state;

    if (selectedCategory.id <= 0) {
      this.showAlert('Выберите категорию для публикации темы');
      return;
    }
    if (title.length < this.titleMinLength) {
      this.showAlert(`Название темы не может быть короче ${this.titleMinLength} символов)`);
      return;
    }
    if (title.length > this.titleMaxLength) {
      this.showAlert(`Название темы не может быть длиннее ${this.titleMaxLength} символов)`);
      return;
    }
    if (getCleanText(editorHtml).length < this.messageMinLength) {
      this.showAlert(
        `Введите ваше сообщение (длина сообщения должна быть не менее ${
          this.messageMinLength
        } символов)`,
      );
      return;
    }
    if (getCleanText(editorHtml).length > this.messageMaxLength) {
      this.showAlert(`Длина сообщения должна быть не более ${this.messageMaxLength} символов)`);
      return;
    }

    const formData = new FormData();
    formData.append('categoryId', selectedCategory.id);
    formData.append('title', title);
    formData.append('text', editorHtml);
    if (attachments) {
      for (const file of attachments) {
        formData.append('attachments', file, file.name);
      }
    }
    this.createTopic(formData);
  };

  showAlert(message, title = '') {
    this.setState({
      modalTitle: title,
      modalMessage: message,
      showModalMessage: true,
    });
  }

  render() {
    const {
      title,
      editorHtml,
      categories,
      selectedCategory,
      isLoading,
      showModalMessage,
      modalTitle,
      modalMessage,
    } = this.state;
    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.forum, text: 'Форум' },
            { url: paths.advocates.forumNewTopic, text: 'Создание новой темы' },
          ]}
        />

        <h1 className="title -third">Создание новой темы</h1>

        <div className="page-container page-container--center">
          <div className="new-theme">
            <div className="input-group new-theme__section">
              <label className="input-group__label" htmlFor="post-section">
                Публикуем в разделе:
              </label>
              <CustomDropdown
                categories={categories}
                selected={selectedCategory}
                placeholder="Выберите раздел"
                onChange={this.handleSelectedCategoryChange}
              />
            </div>

            <div className="input-group new-theme__theme">
              <label className="input-group__label" htmlFor="post-theme">
                Тема вашей публикации:
              </label>
              <input
                className="input-group__input"
                type="text"
                name="post-theme"
                id="post-theme"
                value={title}
                onChange={this.handleTitleChange}
              />
            </div>

            <TextEditor
              editorHtml={editorHtml}
              placeholder="Ваш текст"
              onChange={this.handleTextChange}
              setAttachments={this.setAttachments}
            />

            <button
              className="btn -mobile-full-width new-theme__button"
              onClick={this.handlePostAction}
            >
              Опубликовать
            </button>
          </div>
        </div>
        <MessageModal
          visible={showModalMessage}
          title={modalTitle}
          message={modalMessage}
          hide={() => {
            this.setState({ showModalMessage: false });
          }}
        />
        {isLoading && <GlobalPreloader />}
      </div>
    );
  }
}
